type ToPluralParams = {
  word: string;
  isPlular: boolean;
  ending?: string;
  transformPlural?: (word: string) => string;
};

/**
 * Transform any noun to a plural form.
 *
 * Accepts both flow:
 * 1. Define `ending` in simple cases
 * - Year -> Years
 * - Bus -> Buses
 * 2. Define `transformPlural` in more advice cases.
 * - City -> Cities
 * - Person -> People
 */
export const toPlural = ({
  word,
  isPlular,
  ending = '',
  transformPlural,
}: ToPluralParams) => {
  if (transformPlural) {
    return isPlular ? transformPlural(word) : word;
  }

  return isPlular ? `${word}${ending}` : word;
};
